export const DEFAULT_CONFIG = {
    title: 'پخش زنده تلویزیون',
    type: 'square' as const,
    list_type: 'side' as const,
    list: []
};

export const DEFAULT_NEW_ITEM = {
    title: '',
    image: '',
    url: ''
};

export const VALIDATION_MESSAGES = {
    FILL_ALL_FIELDS: 'لطفا تمام فیلدها را پر کنید',
    INVALID_JSON_STRUCTURE: 'ساختار فایل JSON معتبر نیست',
    INVALID_JSON_FILE: 'فایل JSON نامعتبر است',
    SUCCESSFUL_IMPORT: 'فایل JSON با موفقیت بارگذاری شد'
};

export const DISPLAY_OPTIONS = {
    LIST_TYPES: [
        { value: 'side', label: 'کناری' },
        { value: 'bottom', label: 'پایین' }
    ],
    DISPLAY_TYPES: [
        { value: 'square', label: 'مربع' },
        { value: 'rectangle', label: 'مستطیل' }
    ]
}; 